module.exports = __webpack_public_path__ + "static/media/10.199b52c8.svg";